var map = {
	"./anm-card.png": 1220,
	"./arrow.png": 1221,
	"./arrow.webp": 1222,
	"./asset-1.svg": 1223,
	"./bg-exclusive.webp": 1224,
	"./boost.svg": 1225,
	"./brand-logo-cny.png": 1226,
	"./brand-logo-raya.webp": 1227,
	"./brand-logo.png": 113,
	"./brand-logo.webp": 1228,
	"./btn-black-m.webp": 1229,
	"./btn-blue-m-v2.png": 1230,
	"./btn-blue-m.png": 1231,
	"./btn-blue-m.webp": 1232,
	"./btn-white-m-v2.png": 1233,
	"./btn-white-m.png": 1234,
	"./check-btn.webp": 1235,
	"./default-bg.webp": 1236,
	"./deposit.webp": 1237,
	"./drop-more-btn.webp": 1238,
	"./duitnow.svg": 1239,
	"./eeziepay.svg": 1240,
	"./fcl.svg": 1241,
	"./fcl.webp": 1242,
	"./fpx-logo.svg": 1243,
	"./game-blue.png": 1244,
	"./game-img.png": 1245,
	"./game-white.png": 1246,
	"./global-language.svg": 1247,
	"./grabpay.svg": 1248,
	"./ifm-logo.svg": 1249,
	"./ifm-logo.webp": 1250,
	"./modal-bg.jpg": 1251,
	"./number-bg.webp": 1252,
	"./pagcor.svg": 1253,
	"./pagcor.webp": 1254,
	"./pool-bg.webp": 1255,
	"./promo-given.webp": 1256,
	"./side-bar-bg.png": 1257,
	"./spotlight-base.svg": 1258,
	"./spotlight.svg": 1259,
	"./tether.svg": 1260,
	"./title-asset.svg": 1261,
	"./tng.svg": 1262,
	"./winner.webp": 1263,
	"./withdrawal.webp": 1264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;